import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ReturnUrlService {
  constructor() { }

  public get(): string | undefined {
    var redirectUrl = localStorage.getItem('redirect-url');

    if (redirectUrl == null) {
      return undefined;
    }

    return redirectUrl;
  }

  public set(redirectUrl: string) {
    localStorage.setItem('redirect-url', redirectUrl);
  }

  public remove() {
    localStorage.removeItem('redirect-url');
  }
}
